@if (!isSidebarLink) {
  <div class="recurrence">
    <label class="tt-recurrence_label" for="sidebar-content-recurrence">{{ 'Recurrence' | transloco }}:</label>
    <input
      class="recurrence__input"
      id="sidebar-content-recurrence"
      max="999"
      type="number"
      [disabled]="recurrence() === -1"
      [ngModel]="recurrence()"
      (ngModelChange)="handleRecurrenceChanged($event)" />

    <common-checkbox
      class="recurrence__infinite"
      size="small"
      variant="primary"
      [checked]="recurrence() === -1"
      (checkedChange)="recurrenceChanged.emit($event ? -1 : 0)">
      {{ 'Infinite' | transloco }}
    </common-checkbox>
  </div>
}

<div class="tt-recurrence_interval">
  @if (!isSidebarLink) {
    <span class="tt-recurrence_label">{{ 'RecurrenceInterval' | transloco }}:</span>
  } @else {
    <span class="tt-recurrence_label">{{ 'Flowchart.Links.Offset.Default' | transloco }}:</span>
  }
  <div class="tt-recurrence_interval-buttons">
    <button
      ttButton
      [emphasis]="'regular'"
      [variant]="recurrenceInterval()?.type === TimeSpanType.Min ? 'primary' : 'secondary'"
      (click)="selectRecurrenceIntervalType(TimeSpanType.Min)">
      {{ 'Flowchart.Links.Offset.Minimum' | transloco }}
    </button>
    <button
      ttButton
      [emphasis]="'regular'"
      [variant]="recurrenceInterval()?.type === TimeSpanType.Max ? 'primary' : 'secondary'"
      (click)="selectRecurrenceIntervalType(TimeSpanType.Max)">
      {{ 'Flowchart.Links.Offset.Maximum' | transloco }}
    </button>
    <button
      ttButton
      [emphasis]="'regular'"
      [variant]="recurrenceInterval()?.type === TimeSpanType.Exact ? 'primary' : 'secondary'"
      (click)="selectRecurrenceIntervalType(TimeSpanType.Exact)">
      {{ 'Flowchart.Links.Offset.Exactly' | transloco }}
    </button>
    <button
      ttButton
      [emphasis]="'regular'"
      [variant]="recurrenceInterval()?.type === TimeSpanType.Range ? 'primary' : 'secondary'"
      (click)="selectRecurrenceIntervalType(TimeSpanType.Range)">
      {{ 'Flowchart.Links.Value.Range' | transloco }}
    </button>
  </div>
</div>

@if (recurrenceInterval(); as recurrenceInterval) {
  <div class="tt-recurrence_fromto">
    <div>
      @if (recurrenceInterval.type === TimeSpanType.Range) {
        <label class="tt-recurrence_label">{{ 'From' | transloco }}:</label>
      }

      <tt-interval-input
        [dateType]="fromDateType()"
        [value]="fromNumber()"
        (dateTypeChanged)="handleFromDateTypeChanged($event)"
        (valueChanged)="handleFromNumberChanged($event)" />
    </div>

    @if (recurrenceInterval.type === TimeSpanType.Range) {
      <div>
        <label class="tt-recurrence_label" for="sidebar-content-to">{{ 'To' | transloco }}:</label>

        <tt-interval-input
          [dateType]="toDateType()"
          [value]="toNumber()"
          (dateTypeChanged)="handleToDateTypeChanged($event)"
          (valueChanged)="handleToNumberChanged($event)" />
      </div>
    }
  </div>
}
